import { useState } from "react";

type ShowParams = {
  message?: string;
  timeout?: number;
};

/**
 * Hook to control the visible state of a flash message
 */
const useFlash = () => {
  const [visible, setValue] = useState(false);
  const [message, setMessage] = useState("");

  const show = (params: ShowParams = {}) => {
    const options: ShowParams = {
      message: "",
      timeout: 2500,
      ...params,
    };

    setMessage(options.message);
    setValue(true);

    setTimeout(() => {
      setValue(false);
    }, options.timeout);
  };

  return { visible, show, message } as const;
};

export default useFlash;
